import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IOrganization, IProfile, IPurchasedAllotment, IResponse, IUser } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { AssessmentService } from '../../services/assessment.service';
import { OrganizationService } from '../../services/organization.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { DialogRef } from '@angular/cdk/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { AllotmentService } from '../../services/allotment.service';

@Component({
  selector: 'app-allocate',
  templateUrl: './allocate.component.html',
  styleUrl: './allocate.component.scss'
})
export class AllocateComponent {
  loading = false;

  form: FormGroup;
  users: IUser[] = [];
  orgs: IOrganization[] = [];
  profile: IProfile | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public assessments: IPurchasedAllotment[],
    protected _app_service: AppService,
    protected _allotment_service: AllotmentService,
    protected _org_service: OrganizationService,
    protected _fb: FormBuilder,
    protected _dialog_ref: MatDialogRef<AllocateComponent>
  ) {
    this.form = this._fb.group({
      assessment_id: [null, Validators.required],
      selected_org_id: [null, Validators.required],
      org_name: [null],
      amount: [null, Validators.required]
    })
  }

  ngOnInit() {
    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          return this._org_service.getOrgsById(response.data.org_id)
        }
      )
    ).subscribe(
      (response: IResponse<IOrganization[]>) => {
        this.orgs = response.data;
        this.form.get('org_name')?.setValue(this.orgs[0].name); 
      }
    )
  }

  allocate() {
    this._allotment_service.allocate(this.form.value).subscribe(
      () => {
        this._dialog_ref.close(true)
      },
      (response: HttpErrorResponse) => {
        this._app_service.notify('error', response.error.message);
      }
    )
  }
}
